import React from "react";

import {Grid, TextField, Typography} from "@mui/material";
import {Controller, useFormContext} from "react-hook-form";

type TextFieldProps = {
  name: string;
  label: string;
  disabled?: boolean;
  children?: React.ReactNode;
};

const MWTextField = ({name, label, disabled, children}: TextFieldProps) => {
  const {control} = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({field, fieldState: {error}}) => (
        <Grid container alignItems="center" justifyContent="flex-start">
          <Grid
            item
            xs={0}
            sm={0}
            md={3}
            lg={3}
            xl={3}
            sx={{display: {xs: "none", sm: "none", md: "block"}}}
          >
            <label htmlFor={name}>{label} : </label>
          </Grid>
          <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
            <TextField
              {...field}
              id={name}
              label={label}
              size="small"
              placeholder={label}
              disabled={disabled}
            />
            <Typography color="secondary" sx={{fontSize: "12px"}}>
              {error?.message}
            </Typography>
          </Grid>
          {children}
        </Grid>
      )}
    />
  );
};

export default MWTextField;
